import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * PageViewTracker component
 * Automatically tracks page views in Google Analytics 4 when routes change
 */
const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if gtag is available
    if (typeof window !== 'undefined' && window.gtag) {
      // Track page view with current pathname
      window.gtag('config', 'G-PTX9TKG6V3', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  // This component doesn't render anything
  return null;
};

export default PageViewTracker;
